import { render, staticRenderFns } from "./registro-empleados.vue?vue&type=template&id=2063b7b6&"
import script from "./registro-empleados.vue?vue&type=script&lang=js&"
export * from "./registro-empleados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports